export const programTypesHeight = [1001, 11, 12, 1002, 1, 2, 3, 4]
